<template>
  <div id="home-box" class="grid v-fill-min">
    <div>
      <h3 class="center">Unsere Philosophie:</h3>
      <h2 class="center">Innenausbau oder Möbelstück Holz lebt</h2>
      <h3 class="center">Perfektion macht den kleinen Unterschied</h3>
      <br>
      <div class="avatar grid grid-24">
        <img class="justify-center above-sm-col-span-6 below-md-col-span-24 avatar-image" src="../assets/media/home/uwe_schill.jpeg">
        <div class="align-center above-sm-col-7 above-sm-col-span-17 below-md-col-span-24">
          <h4>Seit 2008 führt Schreinermeister Uwe Schill in Merzhausen das Familienunternehmen in der vierten Generation mit dem gleichen Qualitätsanspruch wie damals und dem besonderen Augenmerk auf Nachhaltigkeit.</h4>
          <p>
            Gemeinsam mit meinem Team erfülle ich mit großem Engagement und Begeisterung die Wünsche unserer Kunden.
            Wir stellen uns Herausforderungen und suchen gemeinsam mit Ihnen nach der perfekten Lösung. Wir beraten, planen und lassen Raum für Kreativität.
          </p>
          <br>
          <p>
            <strong>Unser Anspruch:</strong> Wir sind erst zufrieden, wenn Sie zufrieden sind.
          </p>
        </div>
      </div>
      <br>
      <p>Die Schreinerei Schill bildet aus und engagiert sich darüber hinaus ehrenamtlich für eine Förderklasse für Berufsschüler<br>beim IB Freiburg.</p>
    </div>
    <div id="home-footer" class="grid grid-24">
        <div class="grid h-min-fill above-sm-col-span-12 below-md-col-span-24 justify-content-center">
          <div>Tel:</div>
          <div><a href="tel:+49761402323">0761 / 402323</a></div>
          <div>Fax:</div>
          <div><a href="fax:+49761402907">0761 / 402907</a></div>
          <div>Mail:</div>
          <div><a href="mailto:schreinerei-schill@t-online.de">schreinerei-schill@t-online.de</a></div>
        </div>
        <div class="grid above-sm-col-span-12 below-md-col-span-24">
          <div>Hexentalstraße 14a</div>
          <div>79249 Merzhausen</div>
          <div>Geschäftszeiten Mo - Fr 07:00 - 17:15<br>und jederzeit nach telefonischer Vereinbarung</div>
        </div>
    </div>  
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {};
  }
};
</script>

<style>
.avatar-image {
  object-fit: contain;
  max-width: 100%;
  max-height: 300px;

  border: 8px solid var(--control-background);
  box-shadow: 4px 4px 16px rgb(150, 150, 150);
}

.below-md .avatar{
  grid-template-columns: 1fr;
  grid-template-rows: min-content 1fr;
}

#home-footer{
  grid-column-gap: 0;
  grid-row-gap: 16px;
}

#home-footer a, #home-footer a:visited{
  color: inherit;
  text-decoration: inherit;
}
</style>
